module.exports = __webpack_public_path__ + "img/border_bg@2x.0bf6e6fc.png";